import { Injectable } from '@angular/core';
import { Browser } from '@capacitor/browser';

@Injectable({
  providedIn: 'root',
})
export class BrowserService {
  constructor() {}

  async open(link: string): Promise<void> {
    try {
      await Browser.open({ url: link });
    } catch (error) {
      console.error('Error opening link:', error);
    }
  }
}
